// test365
(365 && 0);
